<template>
    <button class=button-block @click="$emit('button-click')" type=button>{{ buttonText }}</button>
</template>
<script>
export default {
    name : 'buttonBlock',
    props : {
        buttonText : String,
    },
}
</script>